import Backbone from 'backbone';

var Widget_Trigger_Code = Backbone.Model.extend({
    defaults: {
        account_id     : 0,
        project_id     : 0,
        code           : ''
    }
});

export default Widget_Trigger_Code;